import { useCallback } from 'react';
import { DataLayerCategory, DataLayerEvent, } from '@polestar/component-warehouse-react/tokens/analytics/Analytics';
/**
 * Add tracking to click events by using this hook to get the necessary helper functions to be able to define the tracking data and send it.
 *
 * ```
 * const { handleNavigationDrawerTrackingData } = useTrackingData(DataLayerCategory.XXX);
 * ...
 * handleNavigationDrawerTrackingData(DataLayerLabel.MENU_CLOSED, DataLayerAction.MENU_CLICK);
 * ...
 * ```
 *
 * See the DataLayerXXX constants for the available properties or use custom defined ones according to the provided tracking plan.
 *
 * @param category for now this will be by default DataLayerCategory.MENU to prevent upgrade issues but will become required in a future release
 */
const useTrackingData = (
// TODO: make required instead of optional
category = DataLayerCategory.MENU) => {
    const pushDataLayer = useCallback((event) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(event);
    }, []);
    const handleNavigationDrawerTrackingData = useCallback((label, action) => {
        pushDataLayer({
            event: DataLayerEvent.LINK_CLICK,
            category,
            action,
            label,
        });
    }, [pushDataLayer, category]);
    return { handleNavigationDrawerTrackingData, pushDataLayer };
};
export default useTrackingData;
/**
 * Ensure lowercase consistent formatting for tracking labels
 */
export const formatTrackingLabel = (label = '') => label.replace(/\s/g, '_').replace(/_+$/g, '').toLowerCase();
